export default __webpack_public_path__ + "static/chagashover-da2882a085b6787a0a28fe89d0f997b5.png";